import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId,
    userId,
    search = '',
    filters = [],
    order = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.dep.getPage, {
        orgId,
        userId,
        search,
        filters,
        order,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || {};
};
